export function EmptyState({ message }: { message: string }) {
  return <div className="py-2 text-sm text-muted">{message}</div>
}
